<template>
  <div class="banner-box">
    <div class="title-wrapper">
      <TypewriterText :text="`${mainTitle}.`"
                      :delay="typewriterDelay"
                      :typewriter-id="typewriterId"
                      @complete="toggleSideText"
                      class="main-title"/>
    </div>

    <div :id="`${typewriterId}sideText`" class="side-text">
      <p v-if="mainText" class="main-text">{{ mainText }}</p>
      <p v-if="italicText" class="main-text secondary-text italic-text">{{ italicText }}</p>
    </div>

    <div id="bannerShape" :class="bannerClass" class="banner-shape"></div>

    <!-- Scroll indicator -->
    <ScrollDownIndicator v-if="hasScrollIndicator"/>
  </div>
</template>

<script>
import TypewriterText from "@/components/elements/TypewriterText";
import ScrollDownIndicator from "@/components/elements/ScrollDownIndicator";

export default {
  name: "Banner",
  components: {
    ScrollDownIndicator,
    TypewriterText
  },
  props: {
    mainTitle: {
      type: String,
      required: true
    },
    mainText: {
      type: String,
      required: false,
    },
    italicText: {
      type: String,
      required: false,
    },
    typewriterDelay: {
      type: Number,
      required: false,
    },
    typewriterId: {
      type: String,
      required: true,
    },
    bannerClass: {
      type: String,
      required: false,
      default: ''
    },
    hasScrollIndicator: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: () => ({
    bannerShape: null
  }),
  methods: {
    toggleSideText: function () {
      const sideText = document.getElementById(`${this.$props.typewriterId}sideText`);
      sideText.classList.add('side-text-animated')
    }
  },
  mounted() {
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/css/base.mixins";
@import "~@/assets/css/base.variables";
@import "~@/assets/css/base.fonts";
@import "~@/assets/css/base.animations.scss";

// Mobile styling
.banner-box {
  align-items: center;
  display: flex;
  height: calc(100vh - var(--nav-bar-height));
  padding: 0 40px;
  position: relative;
}

.title-wrapper {
  z-index: 2;
}

.side-text {
  @include position-elevation(absolute, $bottom: 30%, $left: 50%, $elevation: 5);
  display: none;
  flex-direction: column;
  font-weight: 700;
  justify-content: center;
  width: max-content;

  .main-text {
    font-size: 18px;
  }

  .secondary-text {
    text-align: center;
  }
}

.side-text-animated {
  display: flex;
  transform: translateX(-50%);
  animation: fade-in 1s;
}

.main-title {
  font-size: 36px;
  font-weight: 900;
  letter-spacing: 5px;
  text-transform: uppercase;

  .dot {
    font-size: 52px;
  }
}

// Banner
.banner-shape {
  @include position-elevation(absolute, $top: 0, $right: 0, $bottom: 0, $left: 140px, $elevation: 1);
  background-color: var(--yellow-main);
}

.banner-red {
  background-color: var(--red-main);
}

.banner-purple {
  background-color: var(--purple-main);
}

.banner-blue-light {
  background-color: var(--blue-light);
}

// Styles
.centered {
  justify-content: center;

  .main-title {
    margin-right: 0;
  }

  .banner-shape {
    left: 0;
    top: 50%;
  }
}

.left {
  justify-content: center;

  .main-title {
  }

  .banner-shape {
    left: 0;
    top: 50%;
  }
}

/** Desktop styling **/
@media screen and (min-width: $screen-md) {
  .banner-box {
    //height: 70vh;
    //height: 100vh;
  }

  .title-wrapper {
  }

  .main-title {
    font-size: 64px;
    margin-right: 50px;

    .dot {
      font-size: 64px;
    }
  }

  .side-text {
    @include position(relative, $bottom: unset, $left: unset);
    transform: translateX(0);
    width: unset;

    .main-text {
      font-size: 24px;
    }

    .secondary-text {
      text-align: left;
    }
  }
  // Styles
  .centered {
    .main-title {
      margin-right: 0;
    }

    .banner-shape {
      left: 50%;
      top: 0;
    }
  }

  .left {
    justify-content: flex-start;

    .main-title {
      margin-right: 50px;
    }

    .banner-shape {
      left: 25%;
      top: 0;
    }
  }
}

// Styles

// Animations
@keyframes left-to-center {
  from {
    left: 100%;
  }
  to {
    left: 50%;
  }
}

@keyframes fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
